import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const StyledContainer = styled.div`
  position: relative;
  height: 30px;
  margin: auto;
  overflow: hidden;
  border-radius: 35px;
  background-color: #FFFFFF;

  @keyframes progress-bar-stripes {
    0% {
      background-position: 40px 0;
    }

    100% {
      background-position: 0 0;
    }
  }
`;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledBar = styled(forwardRef(({ value, maxValue, ...props }, ref) => (<div ref={ref} {...props} />)))`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  border-top-left-radius: 35px;
  border-bottom-left-radius: 35px;
  border: 1px solid #FFFFFF;
  transition: all 1s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  animation: 2s linear infinite progress-bar-stripes;
  background-image: linear-gradient(
    45deg,
    #F37217 25%,
    transparent 25%,
    transparent 50%,
    #F37217 50%,
    #F37217 75%,
    transparent 75%,
    transparent
  );
  background-repeat: repeat-x;
  background-color: #03589C;
  background-size: 40px 40px;

  ${({ value, maxValue }) =>
    css`
      width: ${`${(value * 100) / maxValue}%`};
    `}
`;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledCaption = styled(forwardRef(({ value, maxValue, ...props }, ref) => (<div ref={ref} {...props} />)))`
  position: absolute;
  top: 0;
  bottom: 0;
  border-top-right-radius: 35px;
  border-bottom-right-radius: 35px;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  color: #03589C;

  ${({ value, maxValue }) =>
    css`
      left: ${`${(value * 100) / maxValue}%`};
      width: ${`${100 - (value * 100) / maxValue}%`};
      padding-left: ${theme.spaces.smallX}px;
    `}

  ${({ value, maxValue }) =>
    value >= maxValue &&
    css`
      visibility: hidden;
    `}
`;

const ProgressBar = ({ value, maxValue }) => (
  <StyledContainer>
    <StyledBar value={value} maxValue={maxValue} />
    <StyledCaption value={value} maxValue={maxValue}>
      {((value * 100) / maxValue)?.toFixed()}%
    </StyledCaption>
  </StyledContainer>
);

export default ProgressBar;
